import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  Paper,
  Box,
} from '@mui/material';

import {
  TableCell as StyledTableCell,
  TableRow as StyledTableRow,
} from '../../../components/common/Table';

export default function TabPanelTable(props) {
  return (
    <Box sx={{ p: 4 }}>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 700, p: 3 }} aria-label="tabPanelTable">
          <TableHead>
            <TableRow>
              <StyledTableCell>Uprawa</StyledTableCell>
              <StyledTableCell align="center">
                Powierzchnia (ha)
              </StyledTableCell>
              <StyledTableCell align="center">
                Dochód z uprawy (zł)
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.data
              ?.sort((a, b) => a.id - b.id)
              .map((row) => (
                <StyledTableRow key={row.cropName + '_tab_panel'}>
                  <StyledTableCell component="th" scope="row">
                    {row.cropName}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {Number(row.cropArea.toFixed(2))}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {Number((row.cropArea * row.cropIncomeIndex).toFixed(2))}
                  </StyledTableCell>
                </StyledTableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
